/**
 * The real-day number with a 05:00 reset (docs/design/2026-10-11-daily-loop.md). Pure: the caller passes `now`
 * (ms since the epoch, `Date.now()` on the client or server); shared never reads the clock.
 * Timezone is a fixed offset, Thailand UTC+7 (no daylight saving), so every player's day turns at 05:00 Thai time.
 */
import type { World } from './world';

export const DAY_UTC_OFFSET_HOURS = 7;
export const DAY_RESET_HOUR = 5;
const HOUR_MS = 3_600_000;

/** Whole days since the epoch, counted from 05:00 Thai time. */
export const realDay = (now: number): number =>
  Math.floor((now + (DAY_UTC_OFFSET_HOURS - DAY_RESET_HOUR) * HOUR_MS) / (24 * HOUR_MS));

/** Real-week number, turning Monday 05:00 Thai time (day 0, 1970-01-01, was a Thursday). */
export const realWeek = (now: number): number => Math.floor((realDay(now) + 3) / 7);

/** Pins the small dungeons' daily reward and the training-boost ledger to the real day. Call at login and now and then. */
export function applyRealDay(world: World, now: number): number {
  const d = realDay(now);
  const sys = world.sys;
  // Explicit order (not createSystems's): each day-aware system pins the day / clock.
  for (const x of [sys.smallDungeons, sys.cultivation, sys.sectDance, sys.sectActivities, sys.fameBoards, sys.autoRules]) x.realDay(d, now);
  return d;
}
